/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Parameters Management View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './parametersManagementView';

export const mapStateToPropsParamManagement = mapStateToProps;
export const mapDispatchToPropsParamManagement = mapDispatchToProps;

export default connect(
  mapStateToPropsParamManagement,
  mapDispatchToPropsParamManagement
)(View);
